import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import _ from "lodash";

import RecordTab from "components/tools/record-tab";
import { Button, Row } from "components/ui-kit/styled-templates";

import RoomsApi from "api/rooms-api";

import ModalsService from "services/modals-service";

import { useStorageListener } from "hooks/useStorage";

import { EModals } from "types/enums";

const RoomsPage = () => {
    const { t } = useTranslation();

    const { dormitoryId } = useParams();
    const rooms = useStorageListener(`dormitories.${dormitoryId}.rooms`, []);

    const handlers = {
        openCreateRoomModal: () => ModalsService.showModal(EModals.EditRoom, { data: { details: { isFree: false, isAlwaysAvailable: true } }, mode: `create` }),
        openUpdateRoomModal: (room: any) => () => ModalsService.showModal(EModals.EditRoom, { data: room, mode: `edit` }),
        deleteRoom: (room: any) => () => {
            if (dormitoryId) {
                ModalsService.showModality({
                    title: `Удаление помещения`,
                    description: `Вы уверены, что хотите удалить помещение?`,
                    confirmButton: {
                        children: `Удалить`,
                        background: `red`,
                        onClick: async () => await RoomsApi.deleteRoom(room?.id, dormitoryId),
                    },
                    cancelButton: {
                        background: `grey`,
                        children: `Отмена`,
                    },
                });
            }
        },
    };

    // @ts-ignore
    useEffect(() => RoomsApi.getDormitoryRooms(dormitoryId), [dormitoryId]);
    return (
        <>
            {_.values(rooms)?.map?.((item: any, index: number) => (
                <RecordTab
                    key={index}
                    title={item?.details?.type}
                    description={item?.details?.description}
                    tableData={[
                        {
                            title: `Стоимость на 1 человека`,
                            value: item?.details?.isFree ? `Бесплатно` : `${item?.details?.price} рублей`,
                        },
                    ]}
                    onEditClick={handlers.openUpdateRoomModal(item)}
                    onDeleteClick={handlers.deleteRoom(item)}
                />
            ))}
            <Row extra={`width: inherit; justify-content: flex-start;`}>
                <Button variant="outlined" onClick={handlers.openCreateRoomModal}>
                    {t("q880gxeg13l")}
                </Button>
            </Row>
        </>
    );
};

export default RoomsPage;
